import { render, staticRenderFns } from "./DoKubClosed.vue?vue&type=template&id=1ec04f27&"
import script from "./DoKubClosed.vue?vue&type=script&lang=js&"
export * from "./DoKubClosed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports